import { createMuiTheme } from "@material-ui/core/styles";
import { zhCN } from '@material-ui/core/locale';
export const defaultTheme = createMuiTheme({
  typography: {
    fontFamily: `-apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif`,
    htmlFontSize : 14,
    fontSize : 14,
    body2 : {
      fontSize : "1rem"
    },
    // button : {
      // fontSize : "0.875rem"
    // }
  },
  overrides: {
    MuiTable: {
      root: {
        width: "auto",
        minWidth: "100%"
      }
    },
    MuiTableRow: {
      root: {
        boxSizing: "border-box"
      }
    },
    MuiTableCell: {
      root: {
        // borderWidth: "0.5px 0.5px 0.5px 0.5px",
        // borderColor: "rgba(224, 224, 224, 1)",
        // borderStyle: "solid",
        // boxSizing: "border-box",
        // fontSize : "0.875rem"
      },
      paddingCheckbox: {
        minWidth: "unset"
      }
    },
    MuiButton : {
      textSizeSmall : {
        // fontSize : "0.875rem"
      }
    },
    MuiTablePagination : {
      root : {
        fontSize : "1rem"
      }
    },
    MuiMenuItem : {
      root : {
        fontSize : "1rem"
      }
    }
  },
  palette: {
    primary: {
      main: "#2196F3"
    }
  }
}, zhCN);
